export default "__VITE_ASSET__C$doxWaW__"